<script setup lang="ts">
/**
 * Barre d'avancement d'un dossier : barre DaisyUI `progress` + valeur chiffrée
 * (tabular-nums) pour ne jamais véhiculer l'info par la couleur seule. La teinte
 * passe au succès à 100 %.
 */
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    /** Valeur 0–100. */
    value: number
    /** Libellé optionnel « 3/9 objets remis ». */
    caption?: string
    showValue?: boolean
  }>(),
  { showValue: true },
)

const clamped = computed(() => Math.min(100, Math.max(0, Math.round(props.value))))
const tone = computed(() => (clamped.value >= 100 ? 'progress-success' : 'progress-primary'))
</script>

<template>
  <div class="flex flex-col gap-1">
    <div v-if="showValue || caption" class="flex items-center justify-between gap-2 text-sm">
      <span v-if="caption" class="text-base-content/80">{{ caption }}</span>
      <span v-if="showValue" class="font-semibold tabular-nums text-base-content">{{ clamped }}%</span>
    </div>
    <progress
      :class="['progress w-full', tone]"
      :value="clamped"
      max="100"
      :aria-label="caption ?? `Avancement ${clamped}%`"
    />
  </div>
</template>
